import React from "react";
import {
  SEO,
  PageLayout,
  OutboundLink,
  Location,
  HoursOfOperation,
  SocialMedia,
  Content,
  ImageCollection,
  Reviews,
} from "@bluefin/components";
import { Header, Button, Grid, Image } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class IndexPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <PageLayout subfooter={false} className={"home-page"}>
          <Header
            content={fishermanBusiness.name}
            as={"h1"}
            textAlign={"center"}
            className={"businessName"}
          />
          <div className={"cta-container"}>
            <Button
              primary={true}
              as={OutboundLink}
              to={"https://cash.app/order/$aromadiromacentro"}
              content={"Start Order"}
            />
          </div>
          <Grid
            stackable={true}
            textAlign={"center"}
            className={"grid-locations"}
            verticalAlign={"middle"}
            columns={"1"}
          >
            <Grid.Column width={8} textAlign={"center"} className={""}>
              <Image
                size={"large"}
                className={""}
                centered={true}
                style={{ marginBottom: "1.5rem" }}
                src={
                  "https://fisherman.gumlet.io/public/aromadiroma/AromaDiRoma_Hero_2880x2304_1.jpg"
                }
              />
              <Header
                as={OutboundLink}
                to={"https://cash.app/order/$aromadiromacentro"}
                content={"ORDER ONLINE"}
                size={"medium"}
                textAlign={"medium"}
              />
              <Location
                businessName={"Aroma di Roma Centro"}
                phone={"5624327662"}
                email={""}
                address={{
                  street: "444 W Ocean Blvd, Suite 110",
                  city: "Long Beach",
                  state: "CA",
                  zip: "90802",
                }}
              />
              <HoursOfOperation
                hours={[
                  { close: 1900, day: 1, label: "", open: 700 },
                  { close: 1900, day: 2, label: "", open: 700 },
                  { close: 1900, day: 3, label: "", open: 700 },
                  { close: 1900, day: 4, label: "", open: 700 },
                  { close: 1900, day: 5, label: "", open: 700 },
                  { day: 6, label: "", open: 700, close: 1430 },
                  { day: 7, label: "", open: 700, close: 1430 },
                ]}
                displayOption={"grouped"}
              />
              <SocialMedia
                socialMediaValues={[
                  {
                    type: "facebook",
                    link: "https://www.facebook.com/AromadiRomaCentro/",
                  },
                  {
                    type: "instagram",
                    link: "https://www.instagram.com/aromadiromacentro/?hl=en",
                  },
                ]}
                buttonType={"circle"}
                centerHeader={false}
                colors={"secondary"}
                groupButtons={false}
                groupVertically={false}
                header={""}
                inverted={false}
                labelPosition={"free"}
                showLabels={false}
              />
            </Grid.Column>
          </Grid>
          <Content
            stackable={true}
            className={"home-about-section"}
            textAlign={"center"}
          >
            <Content.Markup truncate={true} paragraphs={2}>
              {fishermanBusiness.aboutMarkdown}
            </Content.Markup>
          </Content>
          <ImageCollection
            images={getComponentFiles({
              components: fishermanBusinessWebsitePage.components,
              componentName: "ImageCollection",
            })}
            as={"gallery"}
            centered={true}
            cutUnevenRows={true}
            smartImageGrouping={false}
            disable={"none"}
            header={""}
            numberOfRowDisplayItems={3}
          />
          <div className={"reviews-container"}>
            <Reviews
              reviews={fishermanBusiness.reviews}
              as={"card"}
              buttonBasic={false}
              buttonSize={"medium"}
              centerHeader={true}
              cardInlinePhoto={"left"}
              header={"Reviews"}
              imageCircular={false}
              imageSize={"small"}
              itemButtonFloat={false}
              itemCenterContent={false}
              itemsDivided={false}
              itemsPerRow={3}
              linkAs={"none"}
              onlyEvenRows={true}
              showImage={true}
              verticalItemAlign={"left"}
            />
          </div>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      aboutMarkdown
      reviews {
        author
        text
        link
      }
    }
    fishermanBusinessWebsitePage(pageType: { eq: "About" }) {
      title
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`;
